<template>
    <div>
        <div class="cart-list">
            <h4>
                小計
                <span v-if="oldOriginTotalPrice !== originTotalPrice" class="red" style="text-decoration: line-through;">${{oldOriginTotalPrice}}</span>
                <span>${{originTotalPrice}}</span>
            </h4>

            <div class="li" v-if="(isCordova || isOnlineOrder) && radioTake==='2'">
                <el-button type="text" class="btn-question" @click="fareModel=true">外送費<i class="el-icon-question i-info"/></el-button>
                <div class="float-right red">
                    <template v-if="deliveryFee > 0">${{deliveryFee}}</template>
                    <template v-else>免外送費</template>
                </div>
            </div>
            <!--todo 外送費說明彈框-->
            <el-dialog
                    v-if="fareModel"
                    :visible.sync="fareModel"
                    :show-close="false"
                    append-to-body
                    custom-class="commDialog">
                <div class="container">
                    <h4 class="text-center">外送費說明</h4>
                    <el-divider class="mt-0"/>
                    <div class="main-content text-left">
                        <div v-for="(item,index) in deliveryConditionList" :key="'deliveryConditionList'+index"
                             class="d-flex mb-3 fixed-w-230">
                            <div class="min-w-80">{{item.distance}}公里以內</div>
                            <div class="flex-grow-1">
                                <template v-if="item.requiredAmount">
                                    滿<b>{{item.requiredAmount}}</b>元
                                </template>
                                <template v-if="item.requiredAmount && item.deliveryFee || item.requiredAmount">
                                    ,
                                </template>
                                <template v-if="item.deliveryFee">
                                    外送費<b class="red">{{item.deliveryFee}}</b>元
                                </template>
                                <span v-else class="red">免運</span>
                            </div>
                        </div>

                        <div v-if="maxDistance" class="blue">超過{{maxDistance}}公里無法使用店家外送</div>
                    </div>

                    <div class="dialog-footer">
                        <el-button type="primary" @click="fareModel = false">確定</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>

        <!--todo 票券折抵-->
        <div class="cart-list" v-if="isCanCoupon && !isTableOrderAddItem">
            <h4 @click="goCoupon(false)">
                目前可使用優惠
                <span class="yellow">
                    <i class="el-icon-present"/> 選擇優惠券
                </span>
            </h4>

            <div v-for="(item2,index2) in couponChoiceListItem" :key="'item2'+index2" class="li">
                {{item2.name+'x'+item2.choiceAmount}}
                <div class="float-right">
                    {{
                        ['', '', '-$' + item2.discountAmount * item2.choiceAmount, '+$' + item2.purchasePrice * item2.choiceAmount, 10 - (Number(item2.discountAmount) / 10) + '折'][item2.couponTypeId]
                    }}
                </div>
            </div>

            <el-divider class="mt-3 mb-3"/>

            <!--todo 紅利點數折抵-->
            <BonusPoints v-if="!isTableOrderAddItem" :list="rewardPointList" @triggerEvent="rewardPointCallBack" />

            <h2 v-if="oldOriginTotalPrice > discountedPrice" class="text-center" style="background-color: #ecd87f;color: #FFFFFF;">
                -共省下${{oldOriginTotalPrice - discountedPrice}}-
            </h2>
        </div>

        <!--todo 付款方式-->
        <div class="cart-list ps">
            <h4 class="mt-3" id="PayType" v-if="!isTableOrderAddItem">
                <el-button type="text" class="btn-question" @click="payModel = true">付款方式<i class="el-icon-question i-info" /></el-button>
                <el-button type="text" @click="showBank = true" v-if="paymentType !== ''"><i class="el-icon-edit" />
                    更改付款方式</el-button>
            </h4>
            <!--todo 付款方式說明彈框-->
            <el-dialog v-if="payModel" :visible.sync="payModel" :show-close="false" append-to-body custom-class="commDialog">
                <div class="container">
                    <h4 class="text-center">付款方式說明</h4>
                    <el-divider class="mt-0" />
                    <div class="main-content text-left">
                        {{ checkoutInstructions }}
                    </div>
                    <div class="dialog-footer">
                        <el-button type="primary" @click="payModel = false">確定</el-button>
                    </div>
                </div>
            </el-dialog>

            <div class="li" @click="showBank = true" :class="required(paymentType)" v-if="!isTableOrderAddItem">
                <span class="red" v-if="paymentType.type === undefined"><i class="el-icon-warning" /> 請選擇付款方式</span>
                <span v-if="paymentType.type !== undefined" class="position-relative">
                    <template v-if="paymentType.type !== 'newebpayMPG'">
                        <img :src="getIcon()" class="card-pic">
                        {{ paymentType.name }}
                        <div class="oinpay-ps" v-if="paymentType.type === 'tokenPayNewebpayMPG'">
                            <span>{{paymentType.payTokenName}}</span>
                            <span v-if="paymentType.card4No !== ''">*{{paymentType.card4No}}</span>
                        </div>
                    </template>
                    <template v-else>
                        <template v-if="paymentType.selectFlag === 0">
                            <img :src="require('@/assets/images/pay/other_pay_credit_card2.svg')" class="card-pic"/>
                            信用卡
                        </template>
                        <template v-else-if="paymentType.selectFlag === 100">
                            <img :src="require('@/assets/images/pay/other_pay_googlepay.svg')" class="card-pic"/>
                            Google Pay
                        </template>
                        <template v-else-if="paymentType.selectFlag === 101">
                            <img :src="require('@/assets/images/pay/other_pay_samsungpay.svg')" class="card-pic"/>
                            Samsung Pay
                        </template>
                        <template v-else>
                            <img :src="require('@/assets/images/pay/other_pay_credit_card2.svg')" class="card-pic"/>
                            信用卡分期 - {{ paymentType.selectFlag }}期
                        </template>
                    </template>
                </span>
                <span class="float-right red">${{ finalPrice }}</span>
            </div>
        </div>

        <!--todo 贈送優惠-->
        <div class="cart-list ps" v-if="orderGift.length > 0">
            <h4>贈送優惠</h4>
            <div v-for="(item3, index3) in orderGift" :key="'item3' + index3" class="li">
                <template v-if="item3.couponType === -1">
                    {{ item3.rewardPointListName }}
                    <span class="float-right">+{{ item3.amount }} 點</span>
                </template>
                <template v-else-if="item3.couponType === -2">
                    {{ item3.loyaltyCardListName }}
                    <span class="float-right">+{{ item3.amount }} 點</span>
                </template>
                <template v-else>
                    {{ item3.couponListName }}
                    <span class="float-right">+{{ item3.amount }} 張</span>
                </template>
            </div>
        </div>
        <!--todo 登入手勢下滑關閉--->
        <PullDownClose v-if="isShowPullDownLogin" @close="closePullDownLogin" class="login-Pull">
            <Login class="content" isWeb isEvent :defaultLoginForm="defaultLoginForm" @close="closePullDownLogin" @triggerEvent="loginEvent"/>
        </PullDownClose>
    </div>
</template>

<script>
import {notNull} from '@/util/common';
import * as constDefine from "@/store/constDefine";
import BonusPoints from "../../order/components/BonusPoints";
import * as mutationTypes from "@/store/mutationTypes";
import PullDownClose from "@/components/PullDownClose";
import Login from  "@/views/auth/Login"

export default {
    name: "NoteBlock",
    props: {
        fromRoute: {},
    },
    components: {
        BonusPoints,//紅利點數
        PullDownClose,
        Login,
    },
    data() {
        return {
            orderSettingTypeId: this.$store.state.cartPageSnapshot.orderSettingTypeId,
            originTotalPrice: this.$store.state.cartPageSnapshot.originTotalPrice,    //小計
            oldOriginTotalPrice: this.$store.state.cartPageSnapshot.oldOriginTotalPrice, //用優惠前小計
            radioTake: this.$store.state.cartPageSnapshot.radioTake,
            fareModel: this.$store.state.cartPageSnapshot.fareModel,       //外送費說明彈框
            couponChoiceListItem: this.$store.state.cartPageSnapshot.couponChoiceListItem,   //已選擇的票券
            couponChoiceList: this.$store.state.cartPageSnapshot.couponChoiceList,       //已選擇的票券選項
            isCanCoupon: this.$store.state.cartPageSnapshot.isCanCoupon,//顯示票券使用欄位(開啟時，可提供顧客使用票券)
            payModel: this.$store.state.cartPageSnapshot.payModel,        //付款說明彈框
            paymentType: this.$store.state.cartPageSnapshot.paymentType,
            // isCreditCard: this.$store.state.cartPageSnapshot.isCreditCard,//高踞信用卡彈框
            orderGift: this.$store.state.cartPageSnapshot.orderGift,      //可獲得票券
            maxDistance: this.$store.state.cartPageSnapshot.maxDistance,//最大運送距離
            couponList: this.$store.state.cartPageSnapshot.couponList,         //優惠表
            calculatorCouponPrice: this.$store.state.cartPageSnapshot.calculatorCouponPrice,    //計算經過coupon的金額
            discountLimit: this.$store.state.cartPageSnapshot.discountLimit,        //優惠限制設定
            storeId: Number(this.$route.query.storeId ? this.$route.query.storeId : this.$store.state.cartStoreId),//店家id(query過來的是修改訂單)
            storeInfo: this.$store.state.cartPageSnapshot.storeInfo,
            checkoutInstructions: this.$store.state.cartPageSnapshot.checkoutInstructions,//結帳說明
            showBank: this.$store.state.cartPageSnapshot.showBank,        //更改付款方式
            finalPrice: this.$store.state.cartPageSnapshot.finalPrice,
            deliveryFee: this.$store.state.cartPageSnapshot.deliveryFee,
            deliveryConditionList: this.$store.state.cartPageSnapshot.deliveryConditionList,//外送費資訊
            concatCouponList: Number(this.$route.query.storeId) > 0,
            removeSubscribe: {},
            isCordova: this.$public.isCordova(),
            isOnlineOrder: Boolean(sessionStorage.getItem("isOnlineOrder")),
            isTableOrderAddItem: false,
            //紅利點數
            rewardPointList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.rewardPointList,                //紅利點數
            rewardPointTakeoutList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.rewardPointTakeoutList,
            rewardPointDeliveryList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.rewardPointDeliveryList,
            rewardPointTableList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.rewardPointTableList,
            useRewardPointIdList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.useRewardPointIdList,
            isLimitDiscountShare: this.$store.state.cartPageSnapshot.orderRewardPointInfo.isLimitDiscountShare,
            isUserData: false,
            discountedPrice: this.$store.state.cartPageSnapshot.discountedPrice,
            isShowPullDownLogin: false,
            dataObject: {},
            defaultLoginForm: {},
        }
    },
    computed: {
        //必填共用判斷
        required() {
            return (type) => {
                //不能為空值
                return type === "" || type === undefined ? 'required' : ''
            }
        },
    },
    created() {
        try {
            let dataObject = this.$crypto.uriComponentToObject(sessionStorage.getItem(constDefine.StorageNameType.TableOrderDataToken));
            if (dataObject.usedType === constDefine.QRCodeUsedType.TableOrderAddItem) {
                this.isTableOrderAddItem = true
            } else if (dataObject.usedType === constDefine.QRCodeUsedType.TableOrder && typeof dataObject.userData !== "undefined") {
                this.isUserData = true;
            }

            this.dataObject = dataObject
        } catch (e) {
            this.isTableOrderAddItem = false
        }
    },
    destroyed() {
        this.removeSubscribe();
    },
    mounted() {
        this.removeSubscribe = this.$store.subscribe((mutation) => {
            if (mutation.type === "updateCartOnlineOrderAndOtherSetting") {
                this.orderDeliveryList = mutation.payload.orderDeliveryList;
                this.userAddressData = mutation.payload.userAddressData;
                this.mealPreparationTimeType = mutation.payload.mealPreparationTimeType;
                this.deliveryConditionList = mutation.payload.deliveryConditionList;
                this.storeInfo = mutation.payload.storeInfo;
                this.maxDistance = mutation.payload.maxDistance;
                this.checkoutInstructions = mutation.payload.checkoutInstructions;
                let self = this;
                //計算經過coupon計算的金額
                this.calculatorCouponPrice = function (price, couponChoiceListItem) {
                    couponChoiceListItem.forEach((item) => {
                        if (item.couponTypeId === 2) {
                            for (let index = 0; index < item.choiceAmount; index++) {
                                price -= item.discountAmount;
                                if (price < 0) price = 0
                            }
                        }
                    });

                    couponChoiceListItem.forEach((item) => {
                        if (item.couponTypeId === 4) {
                            for (let index = 0; index < item.choiceAmount; index++) {
                                price = self.computeType(price * ((100 - item.discountAmount) / 100));
                            }
                        }
                    });

                    if (self.$route.name === "OrderCouponList") {
                        couponChoiceListItem.forEach((item) => {
                            if (item.couponTypeId === 1) {
                                for (let index = 0; index < item.choiceAmount; index++) {
                                    price -= item.posFoodInfo.onlineOrderPrice || 0;
                                    if (price < 0) price = 0
                                }
                            }
                        });
                    }

                    if (self.$route.name === "OrderCart" || self.$route.name === "OrderCouponList") {
                        couponChoiceListItem.forEach((item) => {
                            if (item.couponTypeId === 3) {
                                for (let index = 0; index < item.choiceAmount; index++) {
                                    if (self.$route.name === "OrderCouponList") {
                                        price -= item.posFoodInfo.onlineOrderPrice || 0;
                                    }
                                    price += item.purchasePrice;
                                    if (price < 0) price = 0
                                }
                            }
                        });
                    }

                    return price;
                };
                this.$store.commit("updateCartCalculatorCouponPrice", this.calculatorCouponPrice);
            }
            if (mutation.type === "updateCartFinalPrice") {
                this.finalPrice = mutation.payload;
            }
            if (mutation.type === "updateCartOriginTotalPrice") {
                this.originTotalPrice = mutation.payload;
            }
            if (mutation.type === "updateCartOldOriginTotalPrice") {
                this.oldOriginTotalPrice = mutation.payload;
            }
            if (mutation.type === "updateCartRadioTake") {
                this.radioTake = mutation.payload;
                this.updateRewardPointList(this.radioTake)
            }
            if (mutation.type === "updateCartOnlineOrderAndOtherSetting") {
                this.isCanCoupon = mutation.payload.isCanCoupon;
            }
            if (mutation.type === "updateCartDeliveryFee") {
                this.deliveryFee = mutation.payload;
            }
            if (mutation.type === "updateCartPaymentType") {
                this.paymentType = mutation.payload;
            }
            if (mutation.type === "updateCartShowBank") {
                this.showBank = mutation.payload;
            }
            if (mutation.type === "updateCartOrderGift") {
                this.orderGift = mutation.payload;
            }
            if (mutation.type === "updateCartCouponChoiceList") {
                this.couponChoiceList = mutation.payload;
            }
            if (mutation.type === "updateCartcouponChoiceListItem") {
                this.couponChoiceListItem = mutation.payload;
            }
            if (mutation.type === "updateCartDiscountLimit") {
                this.discountLimit = mutation.payload;
            }
            if (mutation.type === "updateCartDiscountedPrice") {
                this.discountedPrice = mutation.payload;
            }
            if (mutation.type === mutationTypes.setOrderSettingTypeId) {
                this.orderSettingTypeId = mutation.payload;
            }
        });
    },
    updated() {
    },
    methods: {
        setupData() {
            if (notNull(this.fromRoute) && ['OrderCouponList', 'OrderDetail', 'OrderAddressList', 'EditOrderList',].indexOf(this.fromRoute.name) === -1) {  // 取得coupon(3)
                this.$http.fetchWithAuth`GetUserCouponList${{
                    storeId: this.storeId,
                    guide: ['1', '2', '3', '4', '5', '6'],
                }}
                    ${json => {
                        if (this.concatCouponList === true) {
                            let tempCouponList = json.discount.concat(json.offset).concat(json.freebie).concat(json.addPurchase).filter((item) => { return item.isUseStore; });
                            this.couponChoiceListItem.forEach((choiceEle, choiceIndex) => {
                                let forCount = 0;
                                tempCouponList.forEach((couponEle, couponIndex) => {
                                    if (choiceEle.couponListId === couponEle.couponListId && choiceEle.endTime === couponEle.endTime && choiceEle.startTime === couponEle.startTime) {
                                        tempCouponList[couponIndex].count = Number(tempCouponList[couponIndex].count) + Number(choiceEle.choiceAmount);
                                        tempCouponList[couponIndex].choiceAmount = Number(choiceEle.choiceAmount);
                                        choiceEle.code = couponEle.code;
                                        forCount += 1;
                                    }
                                });
                                if (forCount === 0) {
                                    tempCouponList.push(choiceEle);
                                }
                            });
                            this.couponList = tempCouponList;
                            this.concatCouponList = false
                        } else {
                            this.couponList = json.discount.concat(json.offset).concat(json.freebie).concat(json.addPurchase).filter((item) => { return item.isUseStore; });
                            this.couponList.forEach((item) => {
                                this.$set(this.couponChoiceList, item.code, 0);
                            });
                            this.discountLimit = json.orderDiscountLimitSetting;
                        }
                        this.$store.commit("updateCartCouponList", this.couponList);
                        this.$store.commit("updateCartDiscountLimit", this.discountLimit);

                        this.rewardPointDeliveryList = json.rewardPointDeliveryList
                        this.rewardPointTakeoutList = json.rewardPointTakeoutList
                        this.rewardPointTableList = json.rewardPointTableList
                        this.updateRewardPointList(this.radioTake)

                        this.$store.commit(mutationTypes.setOrderRewardPointInfo, {
                            "rewardPointDeliveryList": this.rewardPointDeliveryList,
                            "rewardPointTakeoutList": this.rewardPointTakeoutList,
                            "rewardPointTableList": this.rewardPointTableList,
                        });
                    }}`;
            }
        },
        computeType(number) {
            let self = this
            if (self.storeInfo.discountRole === 0) {
                return Math.round(number)
            } else if (self.storeInfo.discountRole === 1) {
                return Math.ceil(number)
            } else if (self.storeInfo.discountRole === 2) {
                return Math.floor(number)
            }
        },
        goCoupon(isTriggerSubmitCoupon = false) {
            if (!this.isCordova && !this.isUserData && !this.isOnlineOrder) {

                if (this.dataObject.phone) {
                    this.defaultLoginForm = {
                        tel: this.dataObject.phone,
                        countryCodeData: {...this.dataObject.countryCodeData},
                    }
                }

                //桌邊點餐一般網頁版可選擇登入使用優惠
                this.isShowPullDownLogin = true;
                return
            }
            if (this.isLimitDiscountShare) {
                let name = ''
                this.useRewardPointIdList.forEach(rewardPointListId => {
                    this.rewardPointList.forEach(item => {
                        if (item.rewardPointListId === rewardPointListId) {
                            name = item.rewardPointListName
                        }
                    })
                })
                this.$public.showNotify(`${name}不可與其他優惠共用`, false);
            } else {
                //等0.2秒才跳頁，怕有原生鍵盤還未收回就跳頁會跑版
                setTimeout(() => {
                    this.$router.push({ name: 'OrderCouponList', params: { couponList: this.couponList, couponChoiceList: this.couponChoiceList, originTotalPrice: this.originTotalPrice, storeInfo: this.storeInfo, calculatorCouponPrice: this.calculatorCouponPrice, couponChoiceListItem: this.couponChoiceListItem, discountLimit: this.discountLimit, radioTake: this.radioTake, isTriggerSubmitCoupon: isTriggerSubmitCoupon} })
                }, 200);
            }
        },
        checkRewardPointUse(item, amount, isShowNotify) {
            let status = false;
            let subPrice = Number(this.originTotalPrice)
            let useSetting = item.useSetting;
            let name = item.rewardPointListName;
            //根據消費折抵限制換算出來的最多折抵金額
            let conversionAmount = 0
            //最大折抵金額預設跟擁有金額一樣
            let useMaxAmount = item.hasAmount

            if (useSetting.discountLimitType === 2) {
                conversionAmount = this.computeType(subPrice * (useSetting.percentQuota / 100))
            } else if (useSetting.discountLimitType === 3) {
                let ct = Math.floor(subPrice / useSetting.fixedQuotaAmount)
                ct = 1 > ct ? 1 : ct
                conversionAmount = useSetting.fixedQuota * (useSetting.isCumulative ? ct : 1)
            }

            if (this.isLimitDiscountShare && !item.isUse) {//已經有選擇紅利點數且不被共用時，未使用的都不能用了
                if (isShowNotify) {
                    this.$public.showNotify(`既有優惠不可與其優惠共用`, false);
                }
            } else if (!item.isDiscountShare && (
                this.couponChoiceListItem.length > 0 ||
                (this.useRewardPointIdList.length > 1 || (this.useRewardPointIdList.length === 1 && this.useRewardPointIdList.indexOf(item.rewardPointListId) === -1)))) {
                if (isShowNotify) {
                    this.$public.showNotify(`${name}不可與其他優惠共用`, false);
                }
            } else if (amount > item.hasAmount) {
                if (isShowNotify) {
                    this.$public.showNotify(`${name}可折扣金額僅有${this.$public.numberFormat(item.hasAmount)}元`, false);
                }
            } else if (useSetting.isMaxDiscount && amount > useSetting.maxDiscount) {
                if (isShowNotify) {
                    this.$public.showNotify(`${name}單筆折抵上限為${this.$public.numberFormat(useSetting.maxDiscount)}元`, false);
                }
            } else if (useSetting.discountLimitType === 2) {

                if (subPrice < useSetting.percentQuotaAmount || amount > conversionAmount) {
                    if (isShowNotify) {
                        this.$public.showNotify(`${name}需單筆消費滿${this.$public.numberFormat(useSetting.percentQuotaAmount)}元，小計最多可用${this.$public.numberFormat(useSetting.percentQuota)}%點數折抵`, false);
                    }
                } else {
                    status = true;
                }
            } else if (useSetting.discountLimitType === 3) {

                if (subPrice < useSetting.fixedQuotaAmount || amount > conversionAmount) {
                    if (isShowNotify) {
                        this.$public.showNotify(`${name}需單筆消費滿${this.$public.numberFormat(useSetting.fixedQuotaAmount)}元，可用點數折抵${this.$public.numberFormat(useSetting.fixedQuota)}元${useSetting.isCumulative ? '(可累計)' : ''}`, false);
                    }
                } else {
                    status = true;
                }
            } else {
                status = true;
            }

            //有單筆折抵上限時
            if (useSetting.isMaxDiscount && useMaxAmount > useSetting.maxDiscount) {
                useMaxAmount = useSetting.maxDiscount
            }

            //有消費折抵限制上限時
            if (conversionAmount > 0 && useMaxAmount > conversionAmount) {
                useMaxAmount = conversionAmount
            }

            item.useMaxAmount = useMaxAmount

            return status;
        },
        updateRewardPointIsDisabled(isShowNotify = false, isUpdateSelectRewardPoint = false) {
            if (this.rewardPointList.length > 0) {
                this.rewardPointList.forEach((item, index) => {
                    if(this.checkRewardPointUse(item, 0 ,isShowNotify && this.rewardPointList[index].isUse)) {
                        this.$set(this.rewardPointList[index], 'isDisabled', false)
                        if (item.useMaxAmount > 0 && item.useAmount === "" || item.useAmount > item.useMaxAmount) {
                            this.updateRewardPointUseAmount(item, item.useMaxAmount, index)
                        }
                    } else {
                        this.$set(this.rewardPointList[index], 'isDisabled', true)
                        this.$set(this.rewardPointList[index], 'isUse', false)
                    }
                })

                this.refreshRewardPointList()
            }
            //小計異動或進入這頁時要執行 updateSelectRewardPoint
            //避免條件已經異動了，但相關資料尚未連動
            if (isUpdateSelectRewardPoint) {
                this.updateSelectRewardPoint();
            }
        },
        updateRewardPointUseAmount(item, number, index) {
            let tmpHasAmount = item.hasAmount
            let tmpUserPoint = item.rewardPointUserPoint

            tmpHasAmount -= number
            tmpUserPoint -= Math.ceil(number / item.rewardPointListDiscount) * item.rewardPointListPoint

            //因為是component且有脫鉤，所以要改父組件的值
            this.rewardPointList[index] = JSON.parse(JSON.stringify(item))

            this.$set(this.rewardPointList[index], 'useAmount', number)
            this.$set(this.rewardPointList[index], 'tmpHasAmount', tmpHasAmount)
            this.$set(this.rewardPointList[index], 'tmpUserPoint', tmpUserPoint)
        },
        rewardPointCallBack(obj) {
            let event = obj.event;
            if (event === "calculatorCallBack") {
                if (this.rewardPointList.length > obj.index) {
                    let number = parseInt(obj.number)
                    let item = obj.item

                    item.isUse = number > 0
                    this.rewardPointList[obj.index] = JSON.parse(JSON.stringify(item))

                    this.updateSelectRewardPoint()

                    if (this.checkRewardPointUse(item, number, true)) {
                        this.updateRewardPointUseAmount(item, number, obj.index)
                        //子組件有寫監聽這樣才會刷新
                        this.refreshRewardPointList()
                    }
                }
            }
        },
        updateRewardPointList(radioTake) {
            this.useRewardPointIdList = []
            this.isLimitDiscountShare = false

            if (radioTake === '1') {
                this.rewardPointList = JSON.parse(JSON.stringify(this.rewardPointTakeoutList));
            } else if (radioTake === '2') {
                this.rewardPointList = JSON.parse(JSON.stringify(this.rewardPointDeliveryList));
            }

            if (this.orderSettingTypeId === constDefine.OrderSettingType.Table) {
                this.rewardPointList = JSON.parse(JSON.stringify(this.rewardPointTableList));
            }

            this.$store.commit(mutationTypes.setOrderRewardPointInfo, {
                "rewardPointList": this.rewardPointList,
                "useRewardPointIdList": this.useRewardPointIdList,
                "isLimitDiscountShare": this.isLimitDiscountShare,
            });
            this.updateRewardPointIsDisabled(false, false);
        },
        refreshRewardPointList() {
            let rewardPointList = this.rewardPointList
            this.rewardPointList = JSON.parse(JSON.stringify(rewardPointList));
        },
        updateSelectRewardPoint() {
            let useRewardPointIdList = []
            let isLimitDiscountShare = false
            this.rewardPointList.forEach(rewardPointItem => {
                if (rewardPointItem.isUse) {
                    useRewardPointIdList.push(rewardPointItem.rewardPointListId)

                    if (!rewardPointItem.isDiscountShare) {
                        isLimitDiscountShare = true
                    }
                }
            })

            this.useRewardPointIdList = useRewardPointIdList
            this.isLimitDiscountShare = isLimitDiscountShare

            this.$store.commit(mutationTypes.setOrderRewardPointInfo, {
                "useRewardPointIdList": this.useRewardPointIdList,
                "isLimitDiscountShare": this.isLimitDiscountShare,
            });

            this.updateRewardPointIsDisabled(false, false)
        },
        getIcon() {
            if (this.paymentType.imagePath !== "" || this.paymentType.imagePath !== undefined) {
                try {
                    return require('@/assets/images/pay/' + this.paymentType.imagePath)
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.log(error)
                }
            }
            return ""
        },
        //關閉下滑彈窗
        closePullDownLogin(){
            this.isShowPullDownLogin = false;
        },
        loginEvent(obj) {
            let event = obj.event;
            if (event === "result") {
                // NOTE 參考TableOrder.vue有登入的條件調整
                let userData = this.$public.getUserData()
                let countryCodeData = this.$public.getCountryData(userData.countryCode, userData.countryName);
                let dataObject = this.$crypto.uriComponentToObject(sessionStorage.getItem(constDefine.StorageNameType.TableOrderDataToken));
                dataObject.phone = userData.phone
                dataObject.userData = userData
                dataObject.userData.validTimestamp = dataObject.userData.timestamp + (30 * 60 * 1000);
                dataObject.prototypeObject.userData = JSON.parse(JSON.stringify(dataObject.userData))
                dataObject.countryCodeData = countryCodeData !== 0 ? countryCodeData : undefined;
                dataObject.isWebLogin = true
                sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, this.$crypto.objectToURIComponent(dataObject));
                // NOTE 直接用重整的方式，因為重整本來就要可以正常操作
                window.location.reload();
            }
        },
    },
    watch: {
        showBank: {
            handler: function (newVal, oldVal) {
                this.$store.commit("updateCartShowBank", newVal);
            },
            deep: false,
            immediate: false,
        },
        rewardPointList: {
            handler: function () {
                this.$store.commit(mutationTypes.setOrderRewardPointInfo, {
                    "rewardPointList": this.rewardPointList,
                });
            },
            deep: true,
            immediate: true,
        },
        fromRoute: {
            handler: function () {
                if (notNull(this.fromRoute) && this.fromRoute.name === "OrderCouponList") {
                    this.updateRewardPointIsDisabled(false, true)
                }
            },
            deep: true,
            immediate: true,
        },
        originTotalPrice: {
            handler: function () {
                this.updateRewardPointIsDisabled(false, true)
            },
            deep: true,
            immediate: true,
        },
    },
}
</script>
